// extracted by mini-css-extract-plugin
export default {"container":"TokenAiTerm-container___vgFDp"};